import i18n from "@/i18n";

// Canonical keys mirror Domain.Constants.Organization.ReferralSources in rgcq-api.
// LEGACY_UNKNOWN is the sentinel the API backfills onto rows that predate this field.
export const ReferralSourceKey = {
  WEBSITE_OR_ACTIVITIES: "websiteOrActivities",
  WORD_OF_MOUTH: "wordOfMouth",
  SOCIAL_MEDIA: "socialMedia",
  CONDOLEGAL: "condolegal",
  PROFESSIONAL_REFERRAL: "professionalReferral",
  OTHER: "other",
  LEGACY_UNKNOWN: "legacyUnknown"
} as const;

export type ReferralSourceCanonical = keyof typeof ReferralSourceKey;

export function isLegacyReferralSource(canonical: string): boolean {
  return canonical === "LEGACY_UNKNOWN";
}

export function getReferralSourceLabel(canonical: string | undefined): string {
  if (!canonical) return "";
  const key = ReferralSourceKey[canonical as ReferralSourceCanonical];
  if (!key) {
    console.warn(`Unknown referral source canonical value: ${canonical}`);
    return canonical;
  }
  return i18n.t(`organization.referralSources.${key}`);
}
